import { useAuth } from '@/frontend/contexts/AuthContext'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSpinner } from '@fortawesome/free-solid-svg-icons'

/**
 * Component that shows token refresh status to users
 * Provides subtle feedback during automatic token refresh
 */
export default function TokenRefreshIndicator() {
  const { tokenRefreshing } = useAuth()

  if (!tokenRefreshing) {
    return null
  }

  return (
    <div className="fixed top-4 right-4 z-50">
      <div className="bg-blue-50 border border-blue-200 rounded-lg px-4 py-3 shadow-lg flex items-center gap-2">
        <FontAwesomeIcon 
          icon={faSpinner} 
          className="h-4 w-4 text-blue-600 animate-spin" 
        />
        <span className="text-sm text-blue-800 font-medium">
          Refreshing session...
        </span>
      </div>
    </div>
  )
}